import { cva } from "class-variance-authority";

export { default as ActionBar } from "./ActionBar.vue";
export { default as ActionBarTrigger } from "./ActionBarTrigger.vue";
export { default as ActionBarContent } from "./ActionBarContent.vue";
export { default as ActionBarBody } from "./ActionBarBody.vue";
export { default as ActionBarSeparator } from "./ActionBarSeparator.vue";
export { default as ActionBarClose } from "./ActionBarClose.vue";
export { default as ActionBarValue } from "./ActionBarValue.vue";

export const actionBarPositionerVariants = cva(
  "pointer-events-none fixed inset-x-0 bottom-0 z-50 flex px-4 pb-[calc(var(--gutter)+env(safe-area-inset-bottom,0px))]",
  {
    variants: {
      placement: {
        bottom: "justify-center",
        "bottom-start": "justify-start",
        "bottom-end": "justify-end",
      },
    },
    defaultVariants: {
      placement: "bottom",
    },
  }
);
